import { render, staticRenderFns } from "./InsuranceShortfall2.vue?vue&type=template&id=cb8ed1d4"
import script from "./InsuranceShortfall2.vue?vue&type=script&lang=js"
export * from "./InsuranceShortfall2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports